import { Link } from 'react-router-dom';
import Reveal from '../../../shared/Reveal/Reveal';
import NewsletterSubscribeFeedback from '../../../shared/NewsletterSubscribeFeedback/NewsletterSubscribeFeedback';
import { useInsightsSubscribeContent } from '../../../../hooks/useInsightsSubscribeContent';
import { useNewsletterSubscribe } from '../../../../hooks/useNewsletterSubscribe';
import { NEWSLETTER_SOURCES } from '../../../../utils/newsletterSources';
import '../../../shared/NewsletterSubscribeFeedback/NewsletterSubscribeFeedback.css';
import './Subscribe.css';

const Subscribe = () => {
  const { content, isLoading } = useInsightsSubscribeContent();
  const {
    email,
    setEmail,
    isSubmitting,
    isSuccess,
    formError,
    fieldError,
    handleSubmit,
  } = useNewsletterSubscribe(NEWSLETTER_SOURCES.INSIGHTS);

  if (isLoading || !content) {
    return null;
  }

  const { title, text, buttonText, privacy } = content;

  return (
    <section className="insights-subscribe">
      <div className="insights-subscribe__inner">
        <Reveal className="insights-subscribe__panel">
          <div className="insights-subscribe__copy">
            <h2 className="insights-subscribe__title">{title}</h2>
            {text ? <p className="insights-subscribe__text">{text}</p> : null}
          </div>

          <form className="insights-subscribe__form" onSubmit={handleSubmit} noValidate>
            <div className="insights-subscribe__row">
              <label className="insights-subscribe__field">
                <span className="insights-subscribe__sr-only">Email address</span>
                <input
                  className={`insights-subscribe__input${
                    fieldError ? ' newsletter-subscribe-input--error' : ''
                  }`}
                  type="email"
                  name="email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  placeholder="Enter your email"
                  autoComplete="email"
                  disabled={isSubmitting}
                />
              </label>
              <button
                type="submit"
                className="insights-subscribe__button luxury-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Subscribing…' : buttonText}
              </button>
            </div>

            <NewsletterSubscribeFeedback
              formError={formError}
              fieldError={fieldError}
              isSuccess={isSuccess}
            />

            {privacy?.text ? (
              <p className="insights-subscribe__privacy">
                {privacy.text}{' '}
                {privacy.linkText && privacy.linkUrl ? (
                  <Link to={privacy.linkUrl} className="insights-subscribe__privacy-link">
                    {privacy.linkText}
                  </Link>
                ) : null}
              </p>
            ) : null}
          </form>
        </Reveal>
      </div>
    </section>
  );
};

export default Subscribe;
